export const FUNCIONARIOS = {
  label: 'Funcionários',
  value: 'FUNCIONARIOS',
  numberValue: 0,
};

export const SINDICOS = {
  label: 'Síndicos',
  value: 'SINDICOS',
  numberValue: 1,
};

const APP_USAGE_EVOLUTION_ENUM = [FUNCIONARIOS, SINDICOS];

export default APP_USAGE_EVOLUTION_ENUM;
